import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref } from 'vue'
import { useInitDefaultConfig } from './helper'
import type { TOptions } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {

const visible = ref(false)
const closeModal = () => {
  visible.value = false
}
const handleConfirm = () => {
  config.value.onConfirm?.(() => {
    visible.value = false
  })
}
const loading = ref(false)
const config = ref<TOptions>({})
const { initDefaultConfig } = useInitDefaultConfig()

const handleOpen = (option: TOptions) => {
  const { closeOnClickModal = false } = option
  config.value = {
    closeOnClickModal,
    ...initDefaultConfig({
      closeModal,
      handleConfirm,
      loading,
      showCancelButton: option.showCancelButton,
      showConfirmButton: option.showConfirmButton,
      cancelDisabled: option.cancelDisabled,
      confirmDisabled: option.confirmDisabled,
      confirmText: option.confirmText,
    }),
    ...option,
  }
  visible.value = true
}

const handleClose = () => {
  visible.value = false
}
const onClosed = () => {
  config.value = {}
}

__expose({
  handleOpen,
  handleClose,
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    class: "dialog-of-ui",
    "close-on-click-modal": config.value.closeOnClickModal,
    width: config.value.width,
    onClose: config.value.onClose,
    onClosed: onClosed
  }, {
    header: _withCtx(() => [
      (config.value.header)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(config.value.header), { key: 0 }))
        : _renderSlot(_ctx.$slots, "header", { key: 1 })
    ]),
    default: _withCtx(() => [
      (config.value.body)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(config.value.body), { key: 0 }))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    footer: _withCtx(() => [
      (config.value.footer)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(config.value.footer), { key: 0 }))
        : _renderSlot(_ctx.$slots, "footer", { key: 1 })
    ]),
    _: 3
  }, 8, ["modelValue", "close-on-click-modal", "width", "onClose"]))
}
}

})